































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Tree as ElTree } from 'element-ui'
import { authorityInfo, authorize } from '@/api/authority'
import { InitModule } from '@/store/modules/init'
import { UserModule } from '@/store/modules/user'
import router from '@/router'

interface AuthoItem {
  id: number
  name: string
  child: AuthoItem[]
}

interface HoldAuthItem {
  sourceId: number
}

// 权限信息
interface AuthoritieInfoResponse {
  allMenus: AuthoItem[]
  allRouters: AuthoItem[]
  menus: HoldAuthItem[]
  routers: HoldAuthItem[]
}

// 树结构
interface NodeProps {
  id?: number
  label: string
  children?: NodeProps[]
}

@Component({
  name: 'AuthModal'
})
export default class extends Vue {
  @Prop({ default: false }) authDialogFlag!: boolean
  @Prop() id!: number
  @Prop() appId!: number
  private visible = false
  private loading = false
  private allMenusList: NodeProps[] = []
  private allRoutersList: NodeProps[] = []
  private menus: number[] = []
  private routers: number[] = []

  get appList() {
    return InitModule.appList
  }

  get adminId() {
    return UserModule.userInfo.adminId
  }

  // 处理树结构数据
  private handleNodeData(data: AuthoItem[]): NodeProps[] {
    return data.map(item => ({
      id: item.id,
      label: item.name,
      children: item.child.length > 0 ? this.handleNodeData(item.child) : []
    }))
  }

  // 初始化
  private async init() {
    this.loading = true
    const { content: { allMenus, allRouters, menus, routers } } = await authorityInfo<AuthoritieInfoResponse>({ appId: this.appId, id: this.id })
    this.allMenusList = this.handleNodeData(allMenus)
    this.allRoutersList = this.handleNodeData(allRouters)
    this.menus = menus.map(item => item.sourceId)
    this.routers = routers.map(item => item.sourceId)
    this.$nextTick(() => {
      (this.$refs.menuTree as ElTree).setCheckedKeys(this.menus, true);
      (this.$refs.routeTree as ElTree).setCheckedKeys(this.routers, true)
    })
    this.loading = false
  }

  private close() {
    this.$emit('update:authDialogFlag', false)
  }

  private async onSubmit() {
    const menus = (this.$refs.menuTree as ElTree).getCheckedNodes(false, true).map(item=> item.id)
    const routers = (this.$refs.routeTree as ElTree).getCheckedNodes(false, true).map(item=> item.id)
    await authorize({ menus, routers, id: this.id, appId: this.appId })
    this.$message.success('授权成功')
    this.close()
  }

  @Watch('authDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.authDialogFlag
    if (this.visible) {
      // 回填所持有权限
      if (this.id) {
        this.init()
      }
    }
  }
}
